module.exports = __webpack_public_path__ + "img/OBUNoOrder_04.2a12e903.png";